import { TriangleSmallIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import styles from "./ImporterPage.module.scss";

interface Props {
    onNext(): void;
    onPrevious(): void;
    currentIndex: number;
    totalCount: number;
}

export const ImporterPreviewNavigation: React.FC<Props> = ({
    onNext,
    onPrevious,
    currentIndex,
    totalCount,
}) => (
    <div className={styles.documentNav}>
        <span className={styles.documentNavCounter}>
            {currentIndex}{" "}
            <span className={styles.documentNavTotal}>/ {totalCount}</span>
        </span>
        <div className={styles.documentNavArrows}>
            <Button
                variant="secondary"
                size="md"
                iconOnly
                aria-label="Next document"
                onClick={onNext}
                disabled={currentIndex >= totalCount}
            >
                <TriangleSmallIcon />
            </Button>
            <Button
                variant="secondary"
                size="md"
                iconOnly
                aria-label="Previous document"
                onClick={onPrevious}
                disabled={currentIndex <= 1}
            >
                <TriangleSmallIcon className="icon-rotate-180" />
            </Button>
        </div>
    </div>
);
